import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-21f46268"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-x4 xl:mb-x6" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 0,
  class: "title"
}
const _hoisted_5 = { key: 1 }

import { TabContent, Tabs } from '@/shared/navigation/tabs';
import { CustomizerFacetViewModel } from '@/types/productServerApi';
import useMaterialAndColor from '@/shared/product/customizer/ui/overlays/material-and-color/useMaterialAndColor';
import { computed } from 'vue';
import { useBlockLabels } from '@/shared/content/blocks/helpers/block-labels.plugin';


export default /*#__PURE__*/_defineComponent({
  __name: 'SearchFacetMaterials',
  props: {
    facet: null
  },
  setup(__props: any) {

const props = __props as {
    facet: CustomizerFacetViewModel,
}



const { materialFacetOptionsSelectedIndex, getMaterialTabsFromOptions } = useMaterialAndColor();
const labels = useBlockLabels();

const tabTitles = computed(() => getMaterialTabsFromOptions(props.facet.options));

const { setSearchFacetMaterialsFilterByIndex } = useMaterialAndColor();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_unref(Tabs), {
      key: _unref(tabTitles),
      "tab-titles": _unref(tabTitles),
      "default-index": _unref(materialFacetOptionsSelectedIndex),
      onClick: _unref(setSearchFacetMaterialsFilterByIndex)
    }, {
      default: _withCtx(() => [
        _createVNode(_Transition, {
          name: "o-anim-fade-200",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock("div", { key: _unref(materialFacetOptionsSelectedIndex) }, [
              _createVNode(_unref(TabContent), { key: "default" }, {
                default: _withCtx(() => [
                  (_unref(labels).overlayAllMaterialsContentTitle)
                    ? (_openBlock(), _createElementBlock("h3", _hoisted_2, _toDisplayString(_unref(labels).overlayAllMaterialsContentTitle), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    innerHTML: _unref(labels).overlayAllMaterialsContentDescription
                  }, null, 8, _hoisted_3)
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.facet.options, (option, idx) => {
                return (_openBlock(), _createBlock(_unref(TabContent), {
                  key: option.value+idx
                }, {
                  default: _withCtx(() => [
                    (option.description)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_4, _toDisplayString(option.title), 1))
                      : _createCommentVNode("", true),
                    (option.description)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(option.description), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["tab-titles", "default-index", "onClick"]))
  ]))
}
}

})